import { useQuery } from 'react-query';
import { apiClient } from '../api/client';

export interface TaskOverview {
  active_tasks: number;
  queued_tasks: number;
  completed_tasks: number;
  failed_tasks: number;
  total_tasks: number;
}

export const useTaskOverview = () => {
  return useQuery<TaskOverview>(
    'taskOverview',
    async () => {
      const response = await apiClient.get('/api/v1/scraper/statistics/tasks/overview');
      return response.data;
    },
    {
      refetchInterval: 120000,
      staleTime: 60000,
      cacheTime: 300000,
    }
  );
};
